import { jsx as _jsx } from "react/jsx-runtime";
/**
 * BooleanToggleFilter Component
 * Simple toggle switch for boolean filters (e.g., Changed jobs, Posted on LinkedIn)
 */
import { Box, FormControlLabel, Switch } from "@mui/material";
export const BooleanToggleFilter = ({ value, onChange, label = "Enable" }) => {
    const handleChange = (event) => {
        onChange(event.target.checked ? true : null);
    };
    return (_jsx(Box, Object.assign({ sx: { pt: 1.5 } }, { children: _jsx(FormControlLabel, { control: _jsx(Switch, { checked: value === true, onChange: handleChange, size: "small" }), label: label, sx: {
                "& .MuiFormControlLabel-label": {
                    fontSize: "13px",
                },
            } }) })));
};
export default BooleanToggleFilter;
